(function() {
  'use strict';

  function EventsController(
    $log,
    RouterHelper, // Replaced Router with RouterHelper
    $rootScope,
    OrganisationsService,
    Profile,
    EventUtils,
    Auth,
    Security,
    $translate,
    Utils
  ) {
    var ctrl = this;

    ctrl.$onChanges = function() {
      ctrl.options = {
        highlightField: 'name',
        typesToUpdate: ['event', 'eventSection'],
        trackBy: 'id',
        borderClass: function(item) {
          return item.main.getBorderClass();
        }
      };
      ctrl.username = Auth.currentUser();

      if (ctrl.filterId) {
        OrganisationsService.getFilter('epf.events.index', ctrl.filterId)
          .then(function(data) {
            ctrl.resolvedFilter = data;
            ctrl.setup();
          })
          .catch(function(error) {
            $log.warn(error);
          });
      } else {
        ctrl.setup();
      }
    };

    ctrl.setup = function() {
      var listName = ctrl.resolvedFilter ? 'events-' + ctrl.resolvedFilter.id : 'events';

      ctrl.searchModel = Profile.getListPreferences(listName).current;
      ctrl.options.search = ctrl.searchModel;

      var options = {
        defaultFilter: { user: ctrl.username },
        resolvedFilter: ctrl.resolvedFilter,
        own: true
      };
      EventUtils.getList('dbsearch', ctrl.searchModel, options)
        .then(function(list) {
          ctrl.list = list;
          $rootScope.$broadcast('KZCurrentListChange', { list: listName, search: list.search });
          $rootScope.loading = false;
          ctrl.list.doLoadItems();
          Utils.setPageTitle(ctrl.resolvedFilter ? ctrl.resolvedFilter.name : 'Timeline');
          ctrl.loaded = true;
        })
        .catch(function(error) {
          $rootScope.loading = false;
          ctrl.loaded = true;
          $log.warn(error);
        });
    };

    ctrl.actions = [
      {
        label: $translate.instant('Create new'),
        position: 0,
        icon: 'icon-edit',
        route: ['/events/new'],
        showCondition: Security.hasPermission.bind(this, 'events.create.own'),
        klass: 'btn-success'
      },
      {
        label: $translate.instant('Bulk tagging'),
        color: 'warning',
        type: 'link',
        position: 1,
        onClick: function() {
          var prefs = _.assignIn(
            {},
            Profile.getPreferences(),
            {
              bulkTagging: {
                lastPath: {},
                selected: []
              }
            }
          );
          Profile.savePreferences(prefs);
          RouterHelper.navigate(['/events/select']);
        }
      }
    ];
  }

  EventsController.$inject = [
    '$log',
    'RouterHelperService',
    '$rootScope',
    'OrganisationsService',
    'ProfileService',
    'EventUtils',
    'AuthService',
    'SecurityService',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.events')
    .component('events', {
      controller: EventsController,
      controllerAs: 'eventsCtrl',
      templateUrl: 'app/components/events/list.html',
      bindings: {
        filterId: '<'
      }
    });
})();
